export class CardTextModel {

    constructor(
       public textDetail : string,
       public parentIdCard : string
    ) {}
}